// File is deprecated, moved to settings page

import {useState,useRef,useEffect,useCallback,CSSProperties} from 'react';
import ClickableItem from '../../components/ClickableItem';
import Footer from '../../components/Footer';
import './index.css';

import helpIcon from "./assets/help.svg";

import Separator from '../../components/Separator';
import { useMemo } from 'react';
import ProxyInfo from '../../components/ProxyInfo';
import { useNavigate } from 'react-router-dom';
import { Popup } from 'antd-mobile';
import { useTranslation } from "react-i18next";
import { useDaemonContext } from '../../providers/DaemonProvider';

import {openWebLinkNative} from './../../api';

type OptionGroup = {
  id: number;
  heading: string;
  items: {
    id: number;
    icon: string;
    title: string;
    divId?: string;
    childrenText?: string;
    action?: () => void;
  }[]
}

type OptionGroups = OptionGroup[];

export default function Support() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isLocalProxy, isIOS } = useDaemonContext();

  const optionGroups = useMemo<OptionGroups>(() => ([
    
    {
      id: 2,
      heading: "Proxy",
      items: [],
    }, 
    {
      id: 3,
      heading: t('faq'),
      items: [
        {
          id: 1,
          icon: helpIcon,
          title: t('faq'),
          action: () => navigate("/faq"),
        },
        // {
        //   id: 2,
        //   icon: helpIcon,
        //   title: "Config device",
        //   action: () => navigate("/config-device"),
        // }
      ]
    },
    {
      id: 4,
      heading: t('customer-service'),
      items: [
        {
          id: 5,
          icon: helpIcon,
          title: t('customer-service'),
		  //@ts-ignore
          action: () => {openWebLinkNative('https://vue.comm100.com/chatwindow.aspx?siteId=90007504&planId=efd822ce-7299-4fda-9fc1-252dd2f01fc5#',isIOS,isLocalProxy)}
        },
      ]
    }
  ]), [navigate]);

  return (
	
    <div className="page-container">
      <h1>Support</h1>

      <div className="options">
        {

          optionGroups.map((optionGroup,i) => optionGroup.id === 2 ? <div key={i}><ProxyInfo /></div> : (
              <div className="option-group" key={i}>
                <h3>{optionGroup.heading}</h3>
                <div>
                  {optionGroup.items.map((item, index) => (
                    <div key={index}>
                      <div id={item&&item.divId?item.divId:''}><ClickableItem title={item.title} icon={item.icon} action={item?.action}>{item.childrenText && <p>{item.childrenText}</p>}</ClickableItem></div>
                      {index < optionGroup.items.length - 1 && <Separator />}
                    </div>
                  ))}
                </div>
              </div>
          ))
        }
      </div>
      <Footer />
    </div>
  )
}